export default "__VITE_ASSET__BqKeBlNT__"